module.exports = __webpack_public_path__ + "static/media/id-card-svgrepo-com.de9a2be5.svg";